import { render, staticRenderFns } from "./MetaEasyEdit.vue?vue&type=template&id=35bb52c4&scoped=true&"
import script from "./MetaEasyEdit.vue?vue&type=script&lang=js&"
export * from "./MetaEasyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb52c4",
  null
  
)

export default component.exports